import { Outlet } from 'react-router-dom';
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import { AppSidebar } from './AppSidebar';
import { t } from '@/i18n';

/**
 * Minimal shell for admin-only routes that live outside the `:nip` scope
 * (e.g. `/admin/companies`). Mirrors AppShell's sidebar layout but doesn't
 * depend on a company NIP route param — AppShell ties its header title and
 * data loading to `useParams<{ nip }>()`, which is absent here, so reusing
 * it as-is would leave the header blank and run a pointless failed lookup.
 * This wrapper keeps the same visual shell (sidebar + header + content area)
 * without that coupling.
 */
export function AdminLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <span className="text-sm font-medium">{t('navigation.administration')}</span>
        </header>
        <main className="flex-1 overflow-auto p-4 md:p-6">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
